export const COLORS = {
  BLUE: "#00C0FC",
  DARK: "#191919",
  DARK_BLUE: "#0d0e11ff",
  GRAY: "#363636",
  GREEN: "#37F713",
  WHITE: "#FFFFFF",
  WHITE_SMOKE: "#D9D9D9",
};
